import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "wallet-panel-body clickable-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "connector-icon mr-s2" }

import connectors from '@/constants/connectors.json';
import { useWallet } from '@/composables/core/useWallet';
import Icon from '@/components/Icon.vue';
import { Connector } from '@/models/connector';
import { useToast } from 'primevue/usetoast';
import { ToastMessageOptions } from 'primevue/toast';


export default /*#__PURE__*/_defineComponent({
  emits: ["login"],
  setup(__props, { emit }: { emit: ({
  (e: 'login'): void;
}), expose: any, slots: any, attrs: any }) {

const { login } = useWallet();
const toast = useToast();



const wallets: Connector[] = Object.values(connectors);

const loginWallet = async connector => {
  emit('login');
  try {
    await login(connector);
  } catch (e) {
    toast.add({
      severity: 'danger',
      summary: 'Error',
      detail: "You don't have Metamask plugin installed.",
      installLink: 'https://metamask.io/download/',
    } as unknown as ToastMessageOptions);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wallets), (connector, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "flex align-items-center list-item",
        onClick: ($event: any) => {
        loginWallet(connector.id);
        _ctx.$emit('onSelectWallet');
      }
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Icon, {
            name: connector.icon,
            size: "20"
          }, null, 8, ["name"])
        ]),
        _createElementVNode("div", null, _toDisplayString(connector.name), 1)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})